const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/StartPage/LoginButton/LoginButton.tsx';
import { css, cx } from '@emotion/css';
import Icon from '@mui/material/Icon';
import { Paper, Typography } from '@mui/material';
import textMap from './translations';
import React from 'react';
import { theme } from 'App/utils/clientSetupManager';
import { useIntl } from 'react-intl';

interface Props {
    isSelected: boolean | undefined;
    className?: string;
    onClick: () => void;
    text: string;
    iconName: string;
}

const paperStyleCSS = css`
    max-width: 250px;
    max-height: 100%;
    display: flex;
    justify-content: center;
    border-radius: 10px;
    transition:
        background-color 0.3s,
        color 0.3s;
    background-color: ${theme.palette.background.paper};
    color: ${theme.palette.primary.main};
    position: relative;
    padding: 20px;
    box-sizing: border-box;

    &.dimmed {
        background-color: ${theme.palette.background.default};
        color: ${theme.palette.grey[600]};
    }

    &.selected {
        background-color: ${theme.palette.background.paper};
        color: ${theme.palette.primary.main};
    }

    & .selectedIcon {
        width: 32px;
        height: 32px;
        background-color: ${theme.palette.primary.main};
        color: ${theme.palette.primary.contrastText};
        border-radius: 50%;
        padding: 4px;
        position: absolute;
        bottom: -15px;
        right: -15px;
    }
`;

const cssPaperInfoWrapper = css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    & .icon {
        font-size: xxx-large;
        margin-bottom: 16px;
    }

    & p {
        text-align: center;
    }
`;

export const LoginButton = (props: Props) => {
    const { formatMessage } = useIntl();

    return (
        <Paper
            className={cx(paperStyleCSS, props.className, { selected: props.isSelected })}
            onClick={() => props.onClick()}
        >
            {props.isSelected && (
                <div className={'selectedIcon'}>
                    <Icon className={'icons8-checkmark'} />
                </div>
            )}
            <div className={cssPaperInfoWrapper}>
                <Icon className={cx(props.iconName, 'icon')} />
                <Typography variant={'body1'}>{formatMessage(textMap.access)}</Typography>
                <Typography variant={'body1'}>{props.text}</Typography>
            </div>
        </Paper>
    );
};
